import React from 'react'
import { Row } from 'antd'
import { useTranslation } from 'next-i18next'
import { useWindowSize } from 'src/app/hooks'
import styles from './OffersListHeader.module.scss'
import { CustomCol, CustomTitle } from 'src/components'
import OffersFilterByText from './OffersFilterByText/OffersFilterByText'
import OffersFilterByOptions from './OffersFilterByOptions/OffersFilterByOptions'

const OffersListHeader: React.FC<{ offersLength: number }> = ({ offersLength }) => {
  const { t } = useTranslation()
  const { isMobile } = useWindowSize()

  return <Row>
    <CustomCol lg={13}>
      <CustomTitle
        label={t('Offers.HeaderTitle', { length: offersLength })}
        className={isMobile ? 'mb-3' : styles.title}
        type={null}
      />
    </CustomCol>
    <CustomCol lg={8} xs={18}>
      <OffersFilterByText />
    </CustomCol>
    <CustomCol lg={3} xs={4} className='has-text-centered'>
      <OffersFilterByOptions />
    </CustomCol>
  </Row>
}

export default OffersListHeader
